import React, { Component } from 'react';
import { Icon, Tooltip } from '@material-ui/core';
import './PhotoSelector.scss';
import env from '../globals/environment';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

registerPlugin(FilePondPluginImagePreview);

class PhotoSelector extends Component {
  state = { file: null, fileLoading: false, fileId: '' };
  filepond = null;

  handleFileUpload(files) {
    if (files[0].file.size > 3000000) {
      this.props.onFileProcess(null);
      this.props.onError("Photo not added: File must be <3MB");
      this.setState({ fileLoading: false, file: null, fileId: '' });
    }
    else {
      this.setState({ fileLoading: true, fileId: '' });
      this.props.onError('');
      this.props.onFileBeginProcess();
    }
  }

  handleFileProcessed(error, file) {
    // if user cancels image upload, don't show error
    if (!this.state.fileLoading) return;
    if (error) {
      let errorMessage = file.file.size < 3000000 ? "Photo not added: File must be .gif, .png, or .jpg" : "Photo not added: File must be <3MB";
      this.setState({ file: null, fileLoading: false, fileId: '' });
      this.props.onError(errorMessage);
      this.props.onFileProcess(null);
    }
    else {
      const fr = new FileReader();
      fr.onload = (event) => {
        this.props.onFileProcess(event);
        this.props.onError('');
      };
      fr.readAsDataURL(file.file);
      this.setState({ file: file.file, fileLoading: false, fileId: file.serverId });
    }
  }

  removePhoto() {
    this.setState({ file: null, fileLoading: false, fileId: ''  });
    this.props.onError('');
    this.props.onFileProcess(null);
  }

  render() {
    const { token } = this.props;
    const { fileLoading, file } = this.state;
    let addPhotoClass = "add-photo-button";
    let tooltipTitle = "";
    if (file !== null || fileLoading) {
      addPhotoClass += " disabled";
      tooltipTitle = "Only 1 photo permitted";
    }

    return (
      <div className="photo-wrapper">
        <div className={addPhotoClass}>
          <Tooltip title={tooltipTitle} >
            <div onClick={() => { if (file === null) this.filepond.browse(); }} style={{ width: '100%', display: 'flex' }}>
              <Icon className="add-photo-button-icon">photo_camera</Icon>
              <div className="add-photo-button-text">ADD Photo</div>

              <FilePond
                ref={ref => this.filepond = ref}
                dropOnPage={true}
                onprocessfile={(err, file) => { this.handleFileProcessed(err, file); }}
                dropOnElement={false}
                onupdatefiles={(files) => this.handleFileUpload(files)}
                server={{
                  url: `${env.backendUrl}/shoutouts`,
                  process: {
                    url: '/images',
                    method: 'POST',
                    withCredentials: false,
                    headers: { token }
                  },
                  revert: null
                }}
              />
            </div>
          </Tooltip>
        </div>
      </div>
    );
  }
}

export default PhotoSelector;


// WEBPACK FOOTER //
// ./src/components/PhotoSelector.js